import { useDispatch, useSelector } from 'react-redux';

// Stable import path for store hooks.
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
